import type { CourseModule } from "@/core/types";
import { lektionSprechernotizen } from "./lektion-01-sprechernotizen";
import { lektionReferentenansicht } from "./lektion-02-referentenansicht";
import { lektionVortragen } from "./lektion-03-vortragen";

/**
 * Der Notizenbereich und die Einstellungen der Bildschirmpräsentation kommen
 * in der PowerPoint-Schnittstelle von Office.js nicht vor – weder lesend noch
 * schreibend. Geprüft wird deshalb über VBA-Prüfmakros: Sie lesen die Notizen
 * und die Einstellung „Referentenansicht verwenden“ aus und legen sie als
 * Prüfbericht in der Datei ab.
 */
export const modulPraesentieren: CourseModule = {
  id: "praesentieren",
  title: "Sprechernotizen und Präsentieren",
  summary:
    "Das Gegenstück zur schlanken Folie: Sprechernotizen, Notizenseiten für die " +
    "Nachlese und die Referentenansicht. Geprüft wird über ein Prüfmakro, weil " +
    "Office.js die Notizen nicht kennt.",
  level: "Grundlagen",
  lessons: [lektionSprechernotizen, lektionReferentenansicht, lektionVortragen],
};
